import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 17"
}, r = /* @__PURE__ */ o("path", {
  fill: "currentColor",
  d: "M7.667 15.012C3.9 15.012.833 11.945.833 8.18S3.9 1.345 7.667 1.345 14.5 4.412 14.5 8.18s-3.067 6.833-6.833 6.833m0-12.667A5.84 5.84 0 0 0 1.833 8.18a5.84 5.84 0 0 0 5.834 5.833A5.84 5.84 0 0 0 13.5 8.18a5.84 5.84 0 0 0-5.833-5.834M14.667 15.679a.5.5 0 0 1-.354-.147L12.98 14.2a.503.503 0 0 1 0-.707.503.503 0 0 1 .707 0l1.333 1.333a.503.503 0 0 1 0 .707c-.1.1-.227.147-.353.147"
}, null, -1), c = [
  r
];
function l(s, a) {
  return e(), t("svg", n, [...c]);
}
const i = { render: l };
export {
  i as default,
  l as render
};
